export const getFieldValue = (e: React.FormEvent<HTMLFormElement>, id: string): string =>
    (e.currentTarget.querySelector(`#${id}`) as any).value;
